import React from 'react';
import { Icon, IconName } from 'app/common/components/controls';
import { UpgradePromptFull } from 'app/src/components/UpgradePrompts';
import { forNamespace } from 'app/common/lib/util/i18n';
import { trackUe, Noun, Verb } from '@trello/analytics';
const format = forNamespace('upgrade prompt');

export const BoardSidebarPuPUpsell: React.FunctionComponent<{
  billingUrl: string;
}> = ({ billingUrl }) => (
  <span className="board-menu-navigation-item-link disabled">
    <span className="board-menu-navigation-item-link-icon mod-upsell-slot">
      <Icon name={IconName.Private} small className="icon-sm" />
    </span>
    <UpgradePromptFull
      content={format(['board menu', 'power ups', 'content'])}
      headline={format(['board menu', 'power ups', 'headline'])}
      cta={format('learn more')}
      ctaLink={billingUrl}
      ctaOnClick={() =>
        trackUe({
          category: Noun.BOARD_MENU,
          verb: Verb.OPENS,
          directObj: Noun.BC_MODAL,
          method: 'by clicking full upgrade prompt in board menu pup section',
        })
      }
      iconName={IconName.PowerUp}
    />
  </span>
);
